import { createRoutedApp, UpdateNotification, useVersionCheck } from '@room/shared-ui';
import { isBundleMode } from '@room/shared-ui';
import { routes } from './routes';

function UpdateNotifier() {
  const { newVersionAvailable, countdown, reloadNow, dismissUpdate } = useVersionCheck({
    checkInterval: 120000,
    autoReloadDelay: 5000,
    debug: false,
  });

  return (
    <UpdateNotification
      visible={newVersionAvailable}
      countdown={countdown}
      onReload={reloadNow}
      onDismiss={dismissUpdate}
    />
  );
}

export const App = createRoutedApp({
  name: 'Chat',
  basename: '/chat',
  routes,
  sidebar: [],
  additionalContent: isBundleMode() ? null : <UpdateNotifier />,
});
